'use client';
import { useEffect } from 'react';
import { useSession } from 'next-auth/react';

/**
 * Mirrors the NextAuth session onto the browser's Firebase user, on every
 * page (mounted in providers/session-provider.tsx):
 *   - signed in  → Firebase user must be this same uid (replaced if not)
 *   - signed out → Firebase user is signed out too
 * The Firebase SDK is loaded lazily so public pages that never use it don't
 * pay for it up front.
 */
export default function FirebaseAuthSync() {
  const { status, data } = useSession();
  const uid = data?.user?.id;

  useEffect(() => {
    if (status === 'loading') return;

    import('@/firebase/ensure-session')
      .then(({ ensureFirebaseSession, clearFirebaseSession }) => {
        if (status === 'authenticated' && uid) return ensureFirebaseSession(uid);
        if (status === 'unauthenticated') return clearFirebaseSession();
      })
      .catch((e) => console.error('[FirebaseAuthSync] sync failed', e));
  }, [status, uid]);

  return null;
}
